/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Profile from "../Profile";
import Filters from "../Filters";
import { ControlTable } from "../Table";
import useForm from "../../hooks/useForm";
import { isEmpty } from "lodash";
import systemAlert from "../../utils/systemAlert";
import { boardList, deleteBoards } from "../../apis/boards";
import TaxBoard from "./TaxBoard";
import { TAX_BOARD } from "../../constants/NOTICE";

const TaxBoards = (props) => {
  const [fields] = useState([
    {
      title: "제목",
      key: "title",
    },
    {
      title: "유형",
      key: "type",
      onValue: (v) => v === "tax_notice" ? "세무공지" : "세무뉴스"
    },
    {
      title: "작성일",
      key: "createdTime", type: "datetime"
    },
    {
      title: "작성자",
      key: "writeEmployee",
      onValue: (data) => {
        return <Profile data={data} />;
      }
    },
  ]);

  const [filters] = useState([
    {
      title: "제목",
      key: "search.title"
    },
    {
      title: "내용",
      key: "search.content"
    },
  ]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(false);


  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit
  } = useForm({
    order: [
      {
        createdTime: "desc",
      },
    ],
    limit: 10,
    offset: 0,
    companyChecked: false
  });


  const onDelete = () => {
    systemAlert(`"${selectedList[0].title}" ${selectedList.length > 1 ? `외 ${selectedList.length - 1}개` : ``}를(을) 삭제하시겠습니까?`,
      {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: "삭제",
            color: "red",
            onClick: () => {
              deleteBoards({
                idx: selectedList.map(item => item.idx),
                types: TAX_BOARD.map(v => v.value)
              }).then(res => {
                reSubmit();
                setSelectedList([]);
              });
            }
          }
        ]
      }
    );
  };

  const submit = (form) => {
    setIsLoading(true);
    boardList({
      ...form,
      types: ["tax_notice", "tax_news"]
    })
      .then((res) => {
        const { posts = [], total = 0 } = res.data;
        setList(posts);
        setTotal(total);
      }).finally(() => setIsLoading(false));
  };


  const tableButtons = [{
    label: "삭제",
    disabled: isEmpty(selectedList),
    color: 'red',
    action: onDelete
  }, {
    label: "게시물 등록",
    action: () => setOpen(true)
  }];

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);


  const handleOnSelect = (d) => {
    setSelectedItem(d);
    setOpen(true);
  };


  return (
    <>

      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideAllCheck
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        onSelect={handleOnSelect}
      // checkboxDisabled={getCheckboxDisabled}
      />


      <TaxBoard
        open={open}
        setOpen={setOpen}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        submit={reSubmit}
      />
    </>


  );
};

export default TaxBoards;